import React from 'react';
import './App.css';
import Navbar from './Navbar/navbar';



export default () => <Navbar></Navbar>;